// extracted by mini-css-extract-plugin
export default {"main":"main_main__Ql1O0","content":"main_content__7IKUd","side":"main_side__AvtkC"};